import { mutatorAction } from 'satcheljs';
import { bizchatSidepaneStore } from '../store/store';
import { getBizchatLoadedKey } from '../utils/getBizchatLoadedKey';
import type { MailboxInfo } from 'owa-client-types';
import type { WindowKey } from 'owa-bizchat-types';
import { isFeatureEnabled } from 'owa-feature-flags';

export const updateBizchatLoadedMapMutator: (
    isLoaded: boolean,
    mailboxInfo: MailboxInfo,
    windowKey: WindowKey
) => void = mutatorAction('updateBizchatLoadedMapMutator', (isLoaded, mailboxInfo, windowKey) => {
    if (isFeatureEnabled('mon-copilot-bizchat-loading-bar')) {
        const key = getBizchatLoadedKey(mailboxInfo, windowKey);
        bizchatSidepaneStore().isBizchatSidepaneLoadedMap.set(key, isLoaded);
    }
});
